import { render, staticRenderFns } from "./widget-radio.vue?vue&type=template&id=f84da6e2&scoped=true"
import script from "./widget-radio.vue?vue&type=script&lang=js"
export * from "./widget-radio.vue?vue&type=script&lang=js"
import style0 from "./widget-radio.vue?vue&type=style&index=0&id=f84da6e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84da6e2",
  null
  
)

export default component.exports